module.exports = __webpack_public_path__ + "static/img/women_02.dea4085.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c15/women_02.jpg
// module id = iErC
// module chunks = 0